export const navdata = [
    {
        id: 1,
        text: 'home',
        url: '/'
    },
    {
        id: 2,
        text: 'about',
        url: '/about'
    },
    {
        id: 3,
        text: 'blog',
        url: '/blog'
    },
    {
        id: 4,
        text: 'register',
        url: '/register'
    },
    {
        id: 5,
        text: 'contact',
        url: '/contact'
    }
]

export const category = [
    {
        id: 1,
        category: 'Travel',
        title: 'Take only pictures, leave only footprints.',
        cover: '../images/category/travel.jpg',
        res1: '../images/category/travel480.jpg',
        res2: '../images/category/travel1309.jpg',
        res3: '../images/category/travel1891.jpg',
        res4: '../images/category/travel2800w.jpg'

    },
    {
        id: 2,
        category: 'Fashion',
        title: 'Fashions fade, style is eternal.',
        cover: '../images/category/fashion.jpg',
        res1: '../images/category/fashion480.jpg',
        res2: '../images/category/fashion1309.jpg',
        res3: '../images/category/fashion1891.jpg',
        res4: '../images/category/fashion2800w.jpg'
    },
    {
        id: 3,
        category: 'Fitness',
        title: 'Time for some inner peace and wellness.',
        cover: '../images/category/fitness.jpg',
        res1: '../images/category/fitness480.jpg',
        res2: '../images/category/fitness1309.jpg',
        res3: '../images/category/fitness1891.jpg',
        res4: '../images/category/fitness2800w.jpg'

    },
    {
        id: 4,
        category: 'Business',
        title: "Don't wait for opportunities, create them",
        cover: '../images/category/business.jpg',
        res1: '../images/category/business480.jpg',
        res2: '../images/category/business1309.jpg',
        res3: '../images/category/business1891.jpg',
        res4: '../images/category/business2800w.jpg'
    },
    {
        id: 5,
        category: 'Technology',
        title: 'Technology is a useful servant but a dangerous master.',
        cover: '../images/category/tech.jpg',
        res1: '../images/category/tech480.jpg',
        res2: '../images/category/tech1309.jpg',
        res3: '../images/category/tech1891.jpg',
        res4: '../images/category/tech2800w.jpg'

    },
    {
        id: 6,
        category: 'Family',
        title: 'We choose family!',
        cover: '../images/category/family.jpg',
        res1: '../images/category/family480.jpg',
        res2: '../images/category/family1309.jpg',
        res3: '../images/category/family1891.jpg',
        res4: '../images/category/family2800w.jpg'

    },
    {
        id: 7,
        category: 'Sports',
        title: 'The best motivation always comes from within',
        cover: '../images/category/sports.jpg',
        res1: '../images/category/sports480.jpg',
        res2: '../images/category/sports1309.jpg',
        res3: '../images/category/sports1891.jpg',
        res4: '../images/category/sports2800w.jpg'

    },
    {
        id: 8,
        category: 'Writing',
        title: 'Write worth reading or do worth writing.',
        cover: '../images/category/writing.jpg',
        res1: '../images/category/writing480.jpg',
        res2: '../images/category/writing1309.jpg',
        res3: '../images/category/writing1891.jpg',
        res4: '../images/category/writing2800w.jpg'

    },
]

export const cards = [
    {
        id: 1,
        title: 'Home Decor - Essentials',
        desc: "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
        category: 'LifeStyle',
        cover: '../images/blogs/homedecor.jpg',
        res1: '../images/blogs/homedecor480.jpg',
        res2: '../images/blogs/homedecor1309.jpg',
        res3: '../images/blogs/homedecor.jpg',
        res4: '../images/blogs/homedecor.jpg',
        res5: '../images/blogs/homedecor.jpg',
        date: "Dec 05, 2020",
        comments: '12'
    },
    {
        id: 2,
        title: 'Smoldering Summer',
        desc: "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
        category: 'Summer',
        cover: '../images/blogs/beach.jpg',
        res1: '../images/blogs/beach480.jpg',
        res2: '../images/blogs/beach1309.jpg',
        res3: '../images/blogs/beach1891.jpg',
        res4: '../images/blogs/beach2365.jpg',
        res5: '../images/blogs/beach2800.jpg',
        date: "April 15, 2019",
        comments: '23'
    },
    {
        id: 3,
        title: 'Blossom Season',
        desc: "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
        category: 'Flowers',
        cover: '../images/blogs/flowers.jpg',
        res1: '../images/blogs/flowers480.jpg',
        res2: '../images/blogs/flowers1309.jpg',
        res3: '../images/blogs/flowers1891.jpg',
        res4: '../images/blogs/flowers2365.jpg',
        res5: '../images/blogs/flowers2800.jpg',
        date: "June 09, 2021",
        comments: '09'
    },
    {
        id: 4,
        title: 'Must have Makeup',
        desc: "Lorem ipsum, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
        category: 'Fashion',
        cover: '../images/blogs/makeup.jpg',
        res1: '../images/blogs/makeup480.jpg',
        res2: '../images/blogs/makeup1309.jpg',
        res3: '../images/blogs/makeup.jpg',
        res4: '../images/blogs/makeup.jpg',
        res5: '../images/blogs/makeup.jpg',
        date: "January 24, 2021",
        comments: '16'
    },
    {
        id: 5,
        title: 'Healthy Diet',
        desc: "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
        category: 'Health',
        cover: '../images/blogs/health.jpg',
        res1: '../images/blogs/health480.jpg',
        res2: '../images/blogs/health1309.jpg',
        res3: '../images/blogs/health1891.jpg',
        res4: '../images/blogs/health2365.jpg',
        res5: '../images/blogs/health2800.jpg',
        date: "March 17, 2020",
        comments: '27'
    },
    {
        id: 6,
        title: 'Yoga Poses for beginners',
        desc: "Ertt lore muspe enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
        category: 'Fitness',
        cover: '../images/blogs/yoga.jpg',
        res1: '../images/blogs/yoga480.jpg',
        res2: '../images/blogs/yoga1309.jpg',
        res3: '../images/blogs/yoga1891.jpg',
        res4: '../images/blogs/yoga2365.jpg',
        res5: '../images/blogs/yoga2800.jpg',
        date: "April 05, 2018",
        comments: '19'
    },
    {
        id: 7,
        title: 'Will AI takeover',
        desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
        category: 'Tech',
        cover: '../images/blogs/tech.jpg',
        res1: '../images/blogs/tech480.jpg',
        res2: '../images/blogs/tech1309.jpg',
        res3: '../images/blogs/tech1891.jpg',
        res4: '../images/blogs/tech2365.jpg',
        res5: '../images/blogs/tech2800.jpg',
        date: "May 23, 2019",
        comments: '11'
    },
    {
        id: 8,
        title: 'Smart Business Tips',
        desc: "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
        category: 'Business',
        cover: '../images/blogs/business.jpg',
        res1: '../images/blogs/business480.jpg',
        res2: '../images/blogs/business1309.jpg',
        res3: '../images/blogs/business1891.jpg',
        res4: '../images/blogs/business2365.jpg',
        res5: '../images/blogs/business2800.jpg',
        date: "July 16, 2021",
        comments: '06'
    },
    {
        id: 9,
        title: "Travel- Do's and Don'ts",
        desc: "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.s",
        category: 'Travel',
        cover: '../images/blogs/travel.jpg',
        res1: '../images/blogs/travel480.jpg',
        res2: '../images/blogs/travel1309.jpg',
        res3: '../images/blogs/travel1891.jpg',
        res4: '../images/blogs/travel2365.jpg',
        res5: '../images/blogs/travel2800.jpg',
        date: "June 05, 2019",
        comments: '32'
    }
]